import { render, staticRenderFns } from "./DeletePhoto.vue?vue&type=template&id=e35522f6&scoped=true&"
import script from "./DeletePhoto.vue?vue&type=script&lang=js&"
export * from "./DeletePhoto.vue?vue&type=script&lang=js&"
import style0 from "./DeletePhoto.vue?vue&type=style&index=0&id=e35522f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e35522f6",
  null
  
)

export default component.exports